import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Fade } from 'react-reveal';
import { Actions } from '../../flux';
import { images, texts, relacionamentos } from '../../settings';
import { DelayLink, SliderText } from '../../components';

import './ParaOMercado.scss';

class ParaOMercado extends Component {
  constructor(props) {
    super(props);

    this.contentText = React.createRef();
  }

  scrollTop = () => {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  };

  componentDidMount = () => {
    Actions.headerIntern();
    this.scrollTop();
  };

  render = () => {
    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>Para o mercado - {texts.title}</title>
        </Helmet>

        <div className="para-o-mercado-home page-gradient page-gradient--yellow-novo bg-gray" ref="para-o-mercado-home">
          <section className="para-o-mercado-home-area page-gradient__header bg-full">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <div className="page-header">
                      <DelayLink
                        to="/estrategias/nosso-ano"
                        className="button button--aylen button--white-to-yellow button--border-medium button--size-m button--round-l button--text-thick"
                      >
                        Voltar
                      </DelayLink>

                      <h1 className="page-header__title">
                        <span className="gri_text">
                          Para o mercado
                          {/* <span className="gri_label">
                            GRI <b>103-1, 103-2, 103-3</b>
                          </span> */}
                        </span>
                        <small>
                          Clique nos temas <br className="br_desk" />
                          para saber mais
                        </small>
                      </h1>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>

          <section className="para-o-mercado-body">
            <div className="container">
              <div className="row">
                <div className="col-6">
                  <Fade bottom>
                    <DelayLink to="/iniciativa/acoes-emergenciais-marcam-atuacao-na-pandemia" className="card card--yellow with-image">
                      <div className="card__content card__content--full card1">
                        <div className="card__content__header card__content__header--no-border">
                          <h2 className="title title--gray title--large title-card1">
                            Ações
                            <br />
                            emergenciais
                            <br />
                            marcam atuação
                            <br />
                            na pandemia
                          </h2>
                          <img src={images.para_o_mercado.icon1} className="icon1" />
                        </div>
                      </div>
                    </DelayLink>
                  </Fade>
                </div>

                <div className="col-3">
                  <Fade bottom>
                    <DelayLink to="/iniciativa/codigos-de-autorregulacao-sao-atualizados" className="card card--small card--yellow">
                      <div className="card__content card__content--full v-center">
                        <div className="card__content__header card__content__header--no-border">
                          <h2 className="title title--gray title--small">Códigos de autorregulação são atualizados</h2>
                        </div>
                      </div>
                    </DelayLink>
                  </Fade>

                  <Fade bottom>
                    <DelayLink to="/iniciativa/agenda-de-sustentabilidade-avanca-com-pauta-ambiciosa" className="card card--small card--yellow">
                      <div className="card__content card__content--full v-center">
                        <div className="card__content__header card__content__header--no-border">
                          <h2 className="title title--gray title--small">Agenda de sustentabilidade avança com pauta ambiciosa</h2>
                        </div>
                      </div>
                    </DelayLink>
                  </Fade>
                </div>

                <div className="col-3">
                  <Fade bottom>
                    <DelayLink to="/iniciativa/modulo-de-aprendizagem-reforca-carater-educativo" className="card card--small card--yellow">
                      <div className="card__content card__content--full v-center">
                        <div className="card__content__header card__content__header--no-border">
                          <h2 className="title title--gray title--small">
                            Módulo de aprendizagem reforça caráter educativo
                          </h2>
                        </div>
                      </div>
                    </DelayLink>
                  </Fade>
                  <Fade bottom>
                    <DelayLink to="/iniciativa/grupos-consultivos-passam-por-reformulacao" className="card card--small card--yellow">
                      <div className="card__content card__content--full v-center">
                        <div className="card__content__header card__content__header--no-border">
                          <h2 className="title title--gray title--small">Grupos consultivos passam por reformulação</h2>
                        </div>
                      </div>
                    </DelayLink>
                  </Fade>
                </div>
              </div>
            </div>

            <div className="container">
              <div className="row">
                <div className="col-3">
                  <Fade bottom>
                    <DelayLink to="/iniciativa/selic" className="card card--small card--yellow">
                      <div className="card__content card__content--full v-center">
                        <div className="card__content__header card__content__header--no-border">
                          <h2 className="title title--gray title--small">Selic supera meta de disponibilidade</h2>
                        </div>
                      </div>
                    </DelayLink>
                  </Fade>

                  <Fade bottom>
                    <DelayLink to="/iniciativa/cga-e-reformulada-para-acompanhar-dinamismo-do-mercado" className="card card--small card--yellow">
                      <div className="card__content card__content--full v-center">
                        <div className="card__content__header card__content__header--no-border">
                          <h2 className="title title--gray title--small">
                            CGA é reformulada para acompanhar dinamismo do mercado
                          </h2>
                        </div>
                      </div>
                    </DelayLink>
                  </Fade>
                </div>

                <div className="col-3">
                  <Fade bottom>
                    <DelayLink to="/iniciativa/precificacao-de-ativos-ganha-aprimoramentos" className="card card--small card--yellow">
                      <div className="card__content card__content--full v-center">
                        <div className="card__content__header card__content__header--no-border">
                          <h2 className="title title--gray title--small">Precificação de ativos ganha aprimoramentos</h2>
                        </div>
                      </div>
                    </DelayLink>
                  </Fade>
                  <Fade bottom>
                    <DelayLink to="/iniciativa/suspensao-provas" className="card card--small card--yellow">
                      <div className="card__content card__content--full v-center">
                        <div className="card__content__header card__content__header--no-border">
                          <h2 className="title title--gray title--small">Suspensão das provas estimula capacitação</h2>
                        </div>
                      </div>
                    </DelayLink>
                  </Fade>
                </div>

                <div className="col-6">
                  <Fade bottom>
                    <DelayLink
                      to="/iniciativa/pandemia-acelera-agenda"
                      className="card card--yellow card--anbima-data with-image"
                    >
                      <div className="card__content card__content--full card1">
                        <div className="card__content__header card__content__header--no-border">
                          <h2 className="title title--gray title--large title-card1">
                            Pandemia
                            <br />
                            acelera agenda
                            <br />
                            de mercado
                            <br />
                            de capitais
                          </h2>
                          <img src={images.para_o_mercado.icon2} className="icon2" />
                        </div>
                      </div>
                    </DelayLink>
                  </Fade>
                </div>
              </div>
            </div>

            <div className="container">
              <div className="row">
                <div className="row">
                  <div className="col-6">
                    <Fade bottom>
                      <DelayLink to="/iniciativa/raiox-investidor" className="card card--yellow with-image card--small">
                        <div className="card__content card__content--full v-center">
                          <div className="card__content__header card__content__header--no-border w-100">
                            <h2 className="title title--gray title--small">
                              Raio X do Investidor Brasileiro:
                              <br className="br_desk" />
                              tem mais gente economizando
                            </h2>
                            <img src={images.para_o_mercado.icon3} className="icon3" />
                          </div>
                        </div>
                      </DelayLink>
                    </Fade>
                  </div>
                  <div className="col-3">
                    <Fade bottom>
                      <DelayLink to="/iniciativa/atuacao-internacional" className="card card--small card--yellow">
                        <div className="card__content card__content--full v-center">
                          <div className="card__content__header card__content__header--no-border">
                            <h2 className="title title--gray title--small">Atuação internacional é reforçada</h2>
                          </div>
                        </div>
                      </DelayLink>
                    </Fade>
                  </div>

                  <div className="col-3">
                    <Fade bottom>
                      <DelayLink to="/iniciativa/se-liga-na-fraude" className="card card--small card--yellow">
                        <div className="card__content card__content--full v-center">
                          <div className="card__content__header card__content__header--no-border">
                            <h2 className="title title--gray title--small">
                              #SeLigaNaFraude alerta sobre golpes financeiros
                            </h2>
                          </div>
                        </div>
                      </DelayLink>
                    </Fade>

                    {/* <Fade bottom>
                        <DelayLink
                          to="/iniciativas/visitas-educativas-a-gestores-de-patrimonio"
                          className="card card--small card--yellow"
                        >
                          <div className="card__content card__content--full">
                            <div className="card__content__header card__content__header--no-border">
                              <h2 className="title title--gray title--small">
                                Acompanhamento aos gestores de patrimônio
                              </h2>
                            </div>
                          </div>
                        </DelayLink>
                      </Fade> */}
                  </div>
                </div>

                {/* <div className="row">
                    <div className="col-12">
                      <Fade bottom>
                        <DelayLink
                          to="/iniciativa/supervisao-da-precificacao-de-ativos"
                          className="card card--small card--yellow with-image"
                        >
                          <div className="card__content card__content--full">
                            <div className="card__content__header card__content__header--no-border">
                              <h2 className="title title--gray title--small">
                                Supervisão da precificação de ativos <br className="br_desk" />e da distribuição de
                                cotas de fundos
                              </h2>
                              <img src={images.para_o_mercado.grafico_ativos} className="grafico_ativos" />
                            </div>
                          </div>
                        </DelayLink>
                      </Fade>
                    </div>
                  </div> */}
              </div>
            </div>

            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <DelayLink
                      to="/estrategias/dentro-de-casa"
                      className="card card--light-blue card--acoes-dentro-de-casa"
                    >
                      <div className="card__content card__content--full bg-pill-casa">
                        <div className="card__content__header card__content__header--no-border">
                          <h2 className="title title--white title--large title--center center">
                            Confira nossas ações <u>dentro de casa</u>
                          </h2>
                        </div>
                      </div>
                    </DelayLink>
                  </Fade>
                </div>
              </div>
            </div>
          </section>

          <section className="para-o-mercado-footer-area">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade>
                    <div className="box-pill box-pill--green box-pill--center">
                      <div className="box-pill__content box-pill__content--full">
                        <div className="row">
                          <div className="col col-12 col--text">
                            <h4>Veja os eventos de 2020</h4>
                            <DelayLink
                              to="/eventos"
                              className="button button--aylen button--white-to-green button--border-medium button--size-m button--round-l button--text-thick"
                            >
                              Saiba mais
                            </DelayLink>
                          </div>
                          {/* <div className="col col-4 col--image">
                            <img
                              src={images.nosso_ano.pessoa_destaque}
                              className="pessoa_destaque pessoa_destaque--1"
                            />
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  };
}

export { ParaOMercado };
